import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useState } from 'react';
import { useQuery } from 'react-query';
import { useColorContext } from '../ColorContext';
import { ColorPicker } from '../ColorPicker';
import { Dropdown } from 'semantic-ui-react';
import { aggregationMethods } from '../../API';
import * as API from '../../API';
import './CtaGroup.scss';
export const CtaGroup = ({ className, groups, onRemove, onChangeColorScheme, colorScheme, onChangeAggregation, onChangeListExpansion }) => {
    const [colorPickerProps, setColorPickerProps] = useState(null);
    const { data: codeListData } = useQuery('kb/kodeliste', () => API.fetchCodeList());
    const colorContext = useColorContext();
    const onExpand = (groupCat, parentId, expand) => {
        onChangeListExpansion === null || onChangeListExpansion === void 0 ? void 0 : onChangeListExpansion(groupCat, parentId, expand);
    };
    const onChangeColor = (id, color, x, y) => {
        setColorPickerProps({
            currentColor: color,
            x,
            y,
            onChange: (newColor) => {
                onChangeColorScheme === null || onChangeColorScheme === void 0 ? void 0 : onChangeColorScheme(Object.assign(Object.assign({}, colorScheme), { [id]: newColor }));
            },
            onClose: () => setColorPickerProps((prev) => {
                return Object.assign(Object.assign({}, prev), { open: false });
            }),
            open: true
        });
    };
    const jsxGroupList = Object.keys(groups).reduce((acc, groupCat) => {
        const group = groups[groupCat];
        const jsxColorDisc = (affiliation, item, memberId, scalar) => {
            const parentId = item.key;
            const colorId = `${parentId}${memberId !== null && memberId !== void 0 ? memberId : ''}`;
            let color = "#ffffff";
            if (colorScheme === null || colorScheme === void 0 ? void 0 : colorScheme[colorId]) {
                color = colorScheme[colorId];
            }
            else {
                if (!colorScheme) {
                    colorScheme = {};
                }
                color = colorContext.colorFor(parentId, memberId, scalar);
                colorScheme[colorId] = color;
            }
            const disabled = (affiliation === 'parent')
                ? (groupCat !== 'single' && item.aggregation === 'Enkeltkommuner')
                : (item.aggregation !== 'Enkeltkommuner');
            return (_jsx("button", { disabled: disabled, id: colorId, "aria-label": `Endre farge`, title: `Endre farge`, onClick: disabled ? undefined : (e) => {
                    const bounds = e.currentTarget.getBoundingClientRect();
                    onChangeColor(e.currentTarget.id, color, bounds.right, bounds.top);
                }, children: _jsx("svg", { xmlns: "http://www.w3.org/2000/svg", width: "20", height: "20", viewBox: "0 0 20 20", fill: "none", children: _jsx("circle", { className: `color-disc ${affiliation} item_${memberId ? memberId : parentId}`, cx: "10", cy: "10", r: "9", strokeWidth: "2", stroke: disabled ? '#eff0d700' : color, fill: disabled ? '#eff0d700' : color }) }) }));
        };
        return [...acc, ...(group !== null && group !== void 0 ? group : []).map((item) => {
                var _a;
                const clsx = [
                    'cta-group-list-item',
                    groupCat,
                    className !== null && className !== void 0 ? className : '',
                    (item.expanded === true) ? 'expanded' : ''
                ].join(' ');
                const jsxMembers = ((_a = item.members) !== null && _a !== void 0 ? _a : []).map((knr) => {
                    return (_jsxs("li", { children: [_jsx("span", { className: "divider" }), _jsx("span", { className: "color-indicator", children: jsxColorDisc('member', item, knr, item.members.length) }), _jsxs("span", { className: "item-title", children: [knr, " ", codeListData === null || codeListData === void 0 ? void 0 : codeListData.kommuner[knr]] })] }, `k${knr}`));
                });
                const aggregationOpts = aggregationMethods.map(a => ({ key: `aggr_${a.toLowerCase()}`, text: a, value: a, className: a === 'Enkeltkommuner' ? 'spaced' : '' }));
                return (_jsxs("li", { className: clsx, children: [_jsxs("span", { className: "parent", children: [_jsx("span", { className: "color-indicator", children: jsxColorDisc('parent', item, null, 1) }), _jsx("span", { className: "divider" }), _jsxs("span", { className: "item-title", onClick: groupCat !== 'single' ? e => onExpand(groupCat, item.key, !item.expanded) : undefined, children: [item.title, " ", _jsx("span", { className: "chevron" })] }), _jsx("span", { className: "aggregation", children: _jsx("div", { className: "aggregation-select", children: _jsx(Dropdown, { disabled: groupCat === 'single', options: aggregationOpts, value: item.aggregation, text: groupCat === 'single' ? 'Enkeltkommune' : undefined, compact: true, selection: true, onChange: groupCat === 'single' ? undefined : (e, data) => {
                                                if (onChangeAggregation) {
                                                    const aggrMethod = aggregationMethods.find(m => m === data.value);
                                                    if (aggrMethod) {
                                                        onChangeAggregation === null || onChangeAggregation === void 0 ? void 0 : onChangeAggregation(groupCat, item.key, aggrMethod);
                                                    }
                                                }
                                            } }) }) }), _jsx("span", { className: "item-closebtn", onClick: (_) => onRemove === null || onRemove === void 0 ? void 0 : onRemove(groupCat, item.key) })] }), _jsx("ul", { className: "members", children: jsxMembers })] }, item.key));
            })];
    }, []);
    const clsx = [
        'cta-added-groups',
        className !== null && className !== void 0 ? className : ''
    ].join(' ');
    return (_jsxs(_Fragment, { children: [_jsx(ColorPicker, Object.assign({}, colorPickerProps)), _jsx("ul", { className: clsx, children: jsxGroupList })] }));
};
